import React from "react";
import HairServImg from "../HairBotox/HairServImg";
import peachyRoseImg from "./../../../../Images/Blog/Top 10 hairColor/Peachy Rose Gold.png";

const PeachyRose = () => {
  return (
    <div className="blogHead-content">
      <HairServImg hairBotoxImg={peachyRoseImg} />
      <h2>5. Peachy Rose Gold</h2>
      <p>
        For a playful and trendy look, Peachy Rose Gold is a must-try color in
        2024. As one of the <a href="https://scentlifestyle.com/top-10-trending-women-hair-colours-and-highlights-for-2024">Top 10 Trending Women Hair Colours & Highlights for
        2024</a>, this soft, pastel shade combines the warmth of peach with the
        elegance of rose gold. Peachy Rose Gold is perfect for those who want to
        experiment with a unique and eye-catching color. It works well on
        lighter base colors and can be customized to suit your style, whether
        you prefer a full head of color or subtle highlights.
      </p>
    </div>
  );
};

export default PeachyRose;
